// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStoreVerifyCustomerActionToken = (client) => ({
    /**
     * `POST /store/verify-customer-action-token`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreVerifyCustomerActionTokenCreate
     * @source apps/backend/src/api/store/verify-customer-action-token/route.ts
     */
    create: (body, query, headers) => client.fetch("/store/verify-customer-action-token", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=verify-customer-action-token.js.map